var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#FDFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 15.75C29.2861 15.75 26.1443 16.703 23.472 18.4886C20.7997 20.2742 18.7169 22.8121 17.487 25.7814C16.257 28.7507 15.9352 32.018 16.5622 35.1702C17.1893 38.3224 18.7369 41.2179 21.0095 43.4905C23.2821 45.7631 26.1776 47.3107 29.3298 47.9378C32.482 48.5648 35.7493 48.243 38.7186 47.013C41.6879 45.7831 44.2258 43.7003 46.0114 41.028C47.797 38.3557 48.75 35.2139 48.75 32C48.7446 27.6919 47.0309 23.5618 43.9846 20.5155C40.9383 17.4691 36.8081 15.7554 32.5 15.75ZM38.75 33.25H33.75V38.25C33.75 38.5815 33.6183 38.8995 33.3839 39.1339C33.1495 39.3683 32.8315 39.5 32.5 39.5C32.1685 39.5 31.8505 39.3683 31.6161 39.1339C31.3817 38.8995 31.25 38.5815 31.25 38.25V33.25H26.25C25.9185 33.25 25.6005 33.1183 25.3661 32.8839C25.1317 32.6495 25 32.3315 25 32C25 31.6685 25.1317 31.3505 25.3661 31.1161C25.6005 30.8817 25.9185 30.75 26.25 30.75H31.25V25.75C31.25 25.4185 31.3817 25.1005 31.6161 24.8661C31.8505 24.6317 32.1685 24.5 32.5 24.5C32.8315 24.5 33.1495 24.6317 33.3839 24.8661C33.6183 25.1005 33.75 25.4185 33.75 25.75V30.75H38.75C39.0815 30.75 39.3995 30.8817 39.6339 31.1161C39.8683 31.3505 40 31.6685 40 32C40 32.3315 39.8683 32.6495 39.6339 32.8839C39.3995 33.1183 39.0815 33.25 38.75 33.25Z",
    fill: "#0040BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusnew);
export default __webpack_public_path__ + "static/media/plusnew.2413d75b1e5b1a84e4326e1e119344d0.svg";
export { ForwardRef as ReactComponent };